import React from "react";

export enum NodeBracketsPosition {
    TOP,
    BOTTOM
}

export type NodeBracketsProps = {
    nodeBracketPosition: NodeBracketsPosition
}

const NodeBrackets = ({nodeBracketPosition}: NodeBracketsProps) => {
    return <>
        {nodeBracketPosition === NodeBracketsPosition.TOP &&
            <div className={"node-brackets node-brackets__top"} data-testid={"node-brackets-top"}>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1216 1V1C5.08324 1 0.998855 5.08439 0.998855 10.1227L0.998855 24"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.876953 1V1C5.9153 1 9.99968 5.08439 9.99968 10.1227L9.99968 24"/>
                </svg>
            </div>}

        {nodeBracketPosition === NodeBracketsPosition.BOTTOM &&
            <div className={"node-brackets node-brackets__bottom"} data-testid={"node-brackets-bottom"}>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1216 24V24C5.08324 24 0.998855 19.9156 0.998855 14.87727L0.998855 0"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.914062 24V24C5.95241 24 10.0368 19.9156 10.0368 14.87727L10.0368 0"/>
                </svg>
            </div>}
    </>
};

export default NodeBrackets;